import styled, { css } from 'styled-components';
import {
    Text,
    mediaMixin,
    spaceMixin,
} from '@zillow/constellation';

export const StyledText = styled(Text)`
    text-align: center;

    ${mediaMixin('xs', css`
        padding: 0 ${spaceMixin('sm')};
    `)}

    ${mediaMixin('lg', css`
        padding: 0;
    `)}
`;
